
<template>
    <div class="main_table" style="width: 100%">
        <div style="padding-top: 10px; padding-bottom: 10px">
            <el-row>
                <el-col>
                    <span class="title-l1">已定位聚落</span>
                    <el-button
                        type="primary"
                        style="float: right"
                        @click="exportAllPassData"
                        >全部导出</el-button
                    >
                </el-col>
            </el-row>
        </div>

        <el-table
            :header-cell-style="{
                background: '#eef1f6',
                color: '#606266',
            }"
            class="main_table"
            max-height="48rem"
            :data="currentPageData"
            style="
                margin-top: 0.6rem;
                margin-left: 1.6rem;
                margin-right: 1.6rem !important;
                margin-bottom: 0.6rem;
            "
        >
            <el-table-column
                type="index"
                label="序号"
                width="60"
                :index="indexMethod"
            ></el-table-column>
            <el-table-column
                class="text-body"
                label="聚落名称"
                prop="name"
                width="100"
            ></el-table-column>

            <el-table-column
                class="text-body"
                label="记载方位"
                width="150"
                show-overflow-tooltip
            >
                <template slot-scope="scope">
                    {{ getRowfang(scope.row) }}
                </template>
            </el-table-column>
            <!-- <el-table-column
                class="text-body"
                label="今地名"
                prop="n_position"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                class="text-body"
                label="定位依据"
                width="100"
                show-overflow-tooltip
                prop="input_reas"
            ></el-table-column> -->
            <!-- <el-table-column
                class="text-body"
                label="定位单位"
                prop="input_work"
            ></el-table-column> -->
            <el-table-column
                class="text-body"
                label="定位时间"
                prop="input_time"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column class="text-body" label="状态" width="100">
                <template slot-scope="scope">
                    <div
                        v-if="scope.row.check_stat == 1"
                        style="color: #1bc289"
                    >
                        <div
                            style="
                                width: 8px;
                                height: 8px;
                                background: #1bc289;
                                border-radius: 50%;
                                display: inline-block;
                            "
                        ></div>
                        已定位
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button
                        type="text"
                        v-if="scope.row.check_stat == 1"
                        @click="handleClick(scope.row)"
                        ><span
                            style="
                                font-size: 16px;
                                border: 5px solid #1bc289;
                                background: #1bc289;
                                color: white;
                            "
                            >查看</span
                        ></el-button
                    ></template
                >
            </el-table-column>
        </el-table>
        <div class="pagination_fa_div">
            <el-pagination
                background
                :page-size="pageSize"
                layout="prev, pager, next"
                :page-count="totalCount"
                :current-page.sync="currentPageIndex"
                @current-change="handlePageTurn"
            >
            </el-pagination>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import eventBus from '@/V3/js/eventBus'
import table2excel from 'js-table2excel'

export default {
    data() {
        return {
            // 全部的数据
            allPageData: [],
            // 总共有多少条数据
            totalCount: '',
            //
            currentPageData: [],
            // 当前页的分页插件配置
            pageSize: 10,
            totalCount: 0,
            currentPageIndex: 1,
        }
    },
    mounted() {
        this.getBatchData(
            'coor_x>0 and coor_y >0 and location_1=1 and check_stat=1'
        )
    },
    methods: {
        indexMethod(index) {
            return (this.currentPageIndex - 1) * this.pageSize + index + 1
        },
        // 拼接方位字段
        getRowfang(value) {
            let res = value.lev2_name 
            if(value.location != null){
                res +=  '，'

            }
            if (value.location != null) {
                res += value.location
            }
            if (value.distance != 0) {
                res += value.distance
                res += '里'
            }
            return res
        },
        // startIndex 从第几条数据开始获取
        // size 获取几条
        // CQL_FILTER 过滤条件
        // 和右边地图的数据点联动
        getBatchData(CQL_FILTER) {
            let url_params = {
                service: 'WFS',
                version: '1.0.0',
                request: 'GetFeature',
                typeName: 'lwdgis:v3data',
                outputFormat: 'application/json',
                sortBy: 'id',
                CQL_FILTER: CQL_FILTER,
            }
            let self = this
            axios({
                url: $webConfig.V3.owsBaseURL,
                method: 'get',
                params: url_params,
            }).then((res) => {
                self.totalCount = Math.ceil(
                    res.data.totalFeatures / self.pageSize
                )
                let resultTable = []
                res.data.features.forEach((item) => {
                    // 深拷贝
                    // let item = JSON.parse(JSON.stringify(feature))

                    resultTable.push(item.properties)
                })
                self.allPageData = resultTable

                // 给当前页赋值数据
                self.currentPageData = self.allPageData.slice(
                    (self.currentPageIndex - 1) * self.pageSize,
                    self.currentPageIndex * self.pageSize
                )
            })
        },

        // 翻页
        handlePageTurn(val) {
            this.currentPageIndex = val
            // 获取待定位
            // 给当前页赋值数据
            this.currentPageData = this.allPageData.slice(
                (this.currentPageIndex - 1) * this.pageSize,
                this.currentPageIndex * this.pageSize
            )

            // 右边地图联动
            eventBus.emit('pageTurn', {
                startIndex: (val - 1) * this.pageSize,
                size: 10,
                CQL_FILTER:
                    'coor_x>0 and coor_y >0 and location_1=1 and check_stat=1',
            })
        },
        // 点击查看定位
        handleClick(value) {
            eventBus.emit('viewPassJuLuo', value)
        },

        // 导出全部已审核通过的
        exportAllPassData() {
            const column = [
                {
                    title: '样本ID',
                    key: 'id',
                    type: 'text',
                },
                {
                    title: '聚落名称',
                    key: 'name',
                    type: 'text',
                },
                {
                    title: 'lev2',
                    key: 'lev2',
                    type: 'text',
                },
                {
                    title: '所在区县',
                    key: 'lev2_name',
                    type: 'text',
                },
                {
                    title: 'lev3',
                    key: 'lev3',
                    type: 'text',
                },
                {
                    title: '位置信息',
                    key: 'location',
                    type: 'text',
                },
                {
                    title: '户数',
                    key: 'household',
                    type: 'text',
                },
                {
                    title: '口数',
                    key: 'population',
                    type: 'text',
                },
                {
                    title: '距离',
                    key: 'distance',
                    type: 'text',
                },
                {
                    title: '附录',
                    key: 'excursus',
                    type: 'text',
                },
                {
                    title: '普查人员',
                    key: 'censusenum',
                    type: 'text',
                },
                {
                    title: '纬度',
                    key: 'coor_x',
                    type: 'text',
                },
                {
                    title: '经度',
                    key: 'coor_y',
                    type: 'text',
                },
                {
                    title: '今地名',
                    key: 'n_position',
                    type: 'text',
                },
                {
                    title: '定位人员',
                    key: 'user',
                    type: 'text',
                },
                {
                    title: '定位人员真实姓名',
                    key: 'other',
                    type: 'text',
                },
                {
                    title: '定位人员工作单位',
                    key: 'input_work',
                    type: 'text',
                },
                {
                    title: '定位依据',
                    key: 'input_reas',
                    type: 'text',
                },
                {
                    title: '定位日期',
                    key: 'input_time',
                    type: 'text',
                },
                {
                    title: '审核依据',
                    key: 'check_reas',
                    type: 'text',
                },
                {
                    title: '审核日期',
                    key: 'remark',
                    type: 'text',
                },
            ]
            table2excel(
                column,
                this.allPageData,
                this.allPageData[0].name +
                    '-' +
                    this.allPageData[0].lev2_name +
                    '等批量下载'
            )
        },
    },
}
</script>
<style scoped>
.main_table >>> .el-table td {
    padding: 14px 0px !important;
}
.main_table >>> .el-table .cell {
    font-size: 18px;
    font-family: '微软雅黑';
}
</style>



// WEBPACK FOOTER //
// src/V3/Main/ExportData/comLeftTable.vue